import { GetCulpritCroquisSketchQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCroquisSketch/getCulpritCroquisSketchQuery.type';
import { getCulpritCroquisSketchFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCroquisSketch/getCulpritCroquisSketchQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritCroquisSketchQueryOptions = (
  params: GetCulpritCroquisSketchQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['culpritCroquisSketch', params],
    queryFn: () => getCulpritCroquisSketchFunction(params),
    enabled: true,
    meta: {
      onSuccess: params.onSuccess,
    },
  });
};
